export const cottagesInspiration = {
    leftSection: {
        title: "What's new",
        footerLink: {
            title: 'All Travel Guides',
            href: '/blog',
        },
        isMultiColumns: false,
        links: [
            {
                link: {
                    title: 'Why Booking a Cottage Holiday Will Be Your Best Decision Yet',
                    href: '/blog/why-book-a-cottage-holiday',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Things To Do in Cornwall & What To Do on a Cornish Holiday',
                    href: '/blog/things-to-do-in-cornwall',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Discover the Best Things to do in Keswick',
                    href: '/blog/things-to-do-in-keswick',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'The Ultimate Packing List for a Glamping Adventure',
                    href: '/blog/the-ultimate-packing-list-for-glamping',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Best Walking Holiday Hotspots in the UK',
                    href: '/blog/best-walking-holiday-hotspots-in-the-uk',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'A Luxury Retreat for Two in Rural Scotland',
                    href: '/blog/my-stories-couples-retreat-in-scotland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
    rightSection: {
        title: 'Collections',
        footerLink: {
            title: 'All Collections',
            href: '/collections',
        },
        isImageLinks: true,
        links: [
            {
                title: 'Dog Friendly Cottages',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/2XKyVFGJKmSHATETVZqsVM/b6816910fbfe90ef18753497aaaf30b9/Day3_1_0450.jpg?w=300&h=300&fm=webp',
                    alt: 'Dog Friendly Cottages',
                },
                link: {
                    href: '/collections/dog-friendly',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Hot Tub Breaks',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/6fFZuM9PkDj07XOJTQ21B5/b978eec60d34dd4ed26fc4df12846651/Day3_9_1239-2.jpg?w=191&h=142&fm=webp',
                    alt: 'Hot Tub Breaks',
                },
                link: {
                    href: '/collections/hot-tubs',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Short Breaks in UK',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/15cVGGhpydVNcbc3qXy34I/b1a9c9edbee5f5a0a0b7ee88800b4e04/20240615_CDC_Promo_SaleSchoolhols_image_3.jpeg?w=191&h=142&fm=webp',
                    alt: 'Short Breaks in UK',
                },
                link: {
                    href: '/collections/short-breaks',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Luxury Cottages in the UK',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/5zIjIDoLAgWskrIAEQeVMZ/fa78082a6ad841117c626151d5dde96b/M545400-W41.jpg?w=191&h=142&fm=webp',
                    alt: 'Luxury Cottages in the UK',
                },
                link: {
                    href: '/collections/luxury',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Glamping Breaks',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/2fAFetTx3gSUhQ90xdHlGB/596c4b30d9f747d445cf5d759aed2c4c/QU7633-W01.jpg?w=191&h=142&fm=webp',
                    alt: 'Glamping Breaks',
                },
                link: {
                    href: '/collections/glamping',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Cottages With Pool',
                image: {
                    src: 'https://images.ctfassets.net/pyv3dd9w02nv/2g2EVT6bWMrxpDPytHfgvg/79f4b7904df41d1982820299efd119f6/M491646-W01.jpg?w=191&h=142&fm=webp',
                    alt: 'Cottages With Pool',
                },
                link: {
                    href: '/collections/pools',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
};
export const cottagesDestinations = {
    leftSection: {
        title: 'Explore our destinations',
        isMultiColumns: false,
        links: [
            {
                link: {
                    title: 'England',
                    href: '/england',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Scotland',
                    href: '/scotland',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Wales',
                    href: '/wales',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Channel Islands',
                    href: '/channel-islands',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                link: {
                    title: 'Isle of Man',
                    href: '/isle-of-man',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
    rightSection: {
        title: 'Most popular destinations',
        isImageLinks: false,
        links: [
            {
                title: 'Anglesey',
                link: {
                    href: '/wales/anglesey',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Cornwall',
                link: {
                    href: '/england/cornwall',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'County Durham',
                link: {
                    href: '/england/county-durham',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Cumbria',
                link: {
                    href: '/england/cumbria',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Derbyshire',
                link: {
                    href: '/england/derbyshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Devon',
                link: {
                    href: '/england/devon',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Dorset',
                link: {
                    href: '/england/dorset',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Essex',
                link: {
                    href: '/england/essex',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Gloucestershire',
                link: {
                    href: '/england/gloucestershire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Isle of Wight',
                link: {
                    href: '/england/isle-of-wight',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Kent',
                link: {
                    href: '/england/kent',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Lancashire',
                link: {
                    href: '/england/lancashire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Lincolnshire',
                link: {
                    href: '/england/lincolnshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Norfolk',
                link: {
                    href: '/england/norfolk',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Pembrokeshire',
                link: {
                    href: '/wales/pembrokeshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Scottish Highlands',
                link: {
                    href: '/scotland/highlands',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Somerset',
                link: {
                    href: '/england/somerset',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
            {
                title: 'Yorkshire',
                link: {
                    href: '/england/yorkshire',
                    rel: 'noopener noreferrer',
                    openInNew: false,
                },
            },
        ],
    },
};
//# sourceMappingURL=en.js.map